import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './index.css';
import { loadConfig } from './config/runtime';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

// Load runtime config before rendering
loadConfig()
  .then(() => {
    console.log('Config loaded, rendering app...');
    root.render(
      <React.StrictMode>
        <App />
      </React.StrictMode>
    );
  })
  .catch((error) => {
    console.error('Failed to load config:', error);
    // Still render the app with fallback values
    root.render(
      <React.StrictMode>
        <App />
      </React.StrictMode>
    );
  });

// Register service worker for PWA
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker
      .register('/service-worker.js')
      .then((registration) => {
        console.log('Service Worker registered:', registration);
      })
      .catch((error) => {
        console.log('Service Worker registration failed:', error);
      });
  });
}

